import { RootState } from '@dealstack/frontend/app/redux/store';

// User ID of the deal team
export const selectSelectedDealTeamUserId = (state: RootState) => state.deal.selectedDealTeamUserId;
